export default "__VITE_ASSET__C6hKw59d__"